<!--
* @description  参数1
* @fileName  index
* @author userName
* @date 2024-01-15 11:59:53
!-->
<template>
  <div id="index" class="index">
    <div class="Steps-main">
      <!-- <Steps :active="active" :is-bj="true" /> -->
    </div>
    <div class="booking-title"><span>┃</span><span>Booking Summary</span></div>
    <div class="booking-content">
      <div class="content-l">
        <div class="start-end">
          <img
            class="package-img"
            src="../../../../assets/img/client/booking/icon／价格表／飞机.png"
            width="24px"
            height="24px"
          >
          <div class="route">
            <img src="../../../../assets/img/client/booking/dian-icon.png" width="16px" height="16px">
            <div class="line" />
            <img src="../../../../assets/img/client/booking/dian-icon.png" width="16px" height="16px">
          </div>
          <div class="city-name">
            <span>{{ data.startCityNameEn }},{{ data.startProvinceNameEn }},{{ data.startCountryNameEn }},{{ data.startCityZipcode }}</span>
            <span>#{{ data.storeCode }}-{{ data.destCityNameEn }},{{ data.destProvinceNameEn }},{{ data.destCountryNameEn }}</span>
          </div>
        </div>
        <div class="order-info">
          <div class="order-info-l">
            <div>OCEAN LCL</div>
            <div>Door to door</div>
          </div>
          <div class="order-info-r">
            <div>Est. transit time from pickup: {{ data.workDays }} days</div>
            <div v-if="data.goodsReadyType==1">Goods Ready:Goods are ready</div>
            <div v-if="data.goodsReadyType==2">Goods Ready:Within 2 weeks</div>
            <div v-if="data.goodsReadyType==3">Goods Ready:More than 2 weeks</div>
          </div>
        </div>
        <div class="volume-info">
          <div class="volume-info-l">
            <div class="title">Load</div>
            <div class="load-class">
              <div class="number">{{ data.quantity }}</div>
              <span>✖</span>
              <div class="size">
                <div>Boxes/Crates</div>
                <div>Boxes</div>
              </div>
            </div>
          </div>
          <div class="volume-info-r">
            <div class="title">Total weight/volume</div>
            <div class="size">
              <div>{{ data.weight }} KG</div>
              <div>{{ data.volume }} CBM</div>
            </div>
          </div>
        </div>
        <div class="last-info">
          <div v-if="data.customsSupplierId" class="carrier">
            <div class="title">Customs broker:</div>
            <img
              v-if="data.customsSupplierLogo"
              :src="data.customsSupplierLogo"
              width="159px"
              height="56px"
            >
          </div>
          <div v-if="data.insuranceInfo.buyAmount" class="insurance">
            <div class="title">Insurance: {{ data.insuranceInfo.insuranceName }}</div>
            <img
              v-if="data.insuranceInfo.insuranceLogo"
              :src="data.insuranceInfo.insuranceLogo"
              width="159px"
              height="56px"
            >
          </div>
        </div>
        <div class="tip-info">
          <img src="../../../../assets/img/manage/ic_warning@2x.png" width="16px" height="16px">
          <span>
            This rate is valid until Nov 1, 2023. If your goods are not loaded onto a vessel by this date,
            or if the actual Shipment load differs from the Quote, the rate may be subject to an adjustment
            in line with the marketplace rate.
          </span>
        </div>
        <div class="footer-button">
          <button class="by-button--primary" @click="clickConfirm">Confirm & Book Shipment</button>
        </div>
      </div>
      <div class="content-r">
        <div class="price-detalls-bg">
          <span>Price detalls</span>
        </div>
        <div class="price-detalls">
          <div class="detalls-item">
            <div>Quote</div>
            <div>CNY{{ data.subTotal1 }}</div>
          </div>
          <div v-if="data.subTotal2>0" class="detalls-item">
            <div>Customs brokerage and bond</div>
            <div>CNY{{ data.subTotal2 }}</div>
          </div>
          <div class="detalls-item">
            <div>Duties and taxes</div>
            <div>Not Included</div>
          </div>
          <div v-if="data.insuranceInfo.buyAmount" class="detalls-list">
            <div class="detalls-item">
              <div>Insurance</div>
              <div>CNY{{ data.insuranceInfo.insuranceRate }}</div>
            </div>
            <div class="left">Based on value of ${{ data.insuranceInfo.buyAmount }}</div>
          </div>
          <div class="line" />
          <div class="detalls-Total">
            <div>Total</div>
            <div>CNY{{ data.totalAmount }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="isConfirmOrder">
      <ConfirmOrder ref="ConfirmOrder" @close="() => { isConfirmOrder = false }" />
    </div>
  </div>
</template>

<script>
import { GetFbaOrderDetail } from '@/api/order.js'
import ConfirmOrder from './confirmOrder.vue'
import Steps from '../../steps.vue'
import * as define from '@/utils/define.js'
export default {
  name: 'Index',
  components: {
    // 组件的引用
    Steps,
    ConfirmOrder
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      active: 3,
      isConfirmOrder: false,
      data: {
        insuranceInfo: {}
      },
      orderNo: '',
      totalAmount: 0
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
    this.orderNo = this.$route.query.orderNo
    this.init()
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    init() {
      GetFbaOrderDetail(this.orderNo).then(res => {
        if (res.code === 200) {
          this.data = res.data
          // var logoJson = JSON.parse(this.data.shipCompanyLogo)
          // if (logoJson.length > 0) {
          //   this.data.shipCompanyLogo = define.comUrl + logoJson[0].url
          // } else {
          //   this.data.shipCompanyLogo = undefined
          // }
          if (this.data.customsSupplierLogo) {
            var logoJson = JSON.parse(this.data.customsSupplierLogo)
            if (logoJson.length > 0) {
              this.data.customsSupplierLogo = define.comUrl + logoJson[0].url
            } else {
              this.data.customsSupplierLogo = undefined
            }
          }
          if (this.data.insuranceInfo.insuranceLogo) {
            this.data.insuranceInfo.insuranceLogo = define.comUrl + this.data.insuranceInfo
              .insuranceLogo
          } else {
            this.data.insuranceInfo.insuranceLogo = undefined
          }
          this.data.subTotal1 = this.data.traffic
          this.data.feeList.forEach(item => {
            this.data.subTotal1 += item.totalAmount
          })
          this.data.subTotal1 += this.data.startLiftgateAmount
          this.data.subTotal2 = this.data.bondAmount + this.data.ISFBondAmount
          this.data.customsFeeList.forEach(item => {
            this.data.subTotal2 += item.totalAmount
          })
          if (this.data.insuranceInfo.buyAmount) {
            this.totalAmount += this.data.insuranceInfo.insuranceRate
          }
        }
      })
    },
    // 方法
    clickConfirm() {
      this.isConfirmOrder = true
      this.$nextTick(() => {
        this.$refs.ConfirmOrder.init(this.data)
      })
    }
  }
}
</script>
<style scoped lang='scss'>
	.flex1 {
		display: flex;
		justify-content: space-between;
	}

	.font-class {
		font-size: 13px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: #333333;

		div:nth-of-type(1) {
			font-weight: 600;
		}
	}

	.title-class {
		font-size: 13px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 600;
		color: #333333;
		height: 40px;
		text-align: left;
		line-height: 40px;
	}

	.index {
		margin: 0 auto;
		width: 1200px;

		.Steps-main {
			padding-top: 40px;
		}

		.booking-title {
			height: 32px;
			text-align: left;
			margin: 20px 0;

			span:nth-of-type(1) {
				color: #E95506;
				margin-right: 12px;
			}

			span:nth-of-type(2) {
				font-size: 18px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 600;
				color: #333333;
			}
		}

		.booking-content {
			display: flex;

			.content-l {
				width: 894px;

				.start-end {
					width: 894px;
					height: 152px;
					background: #FFFFFF;
					border-radius: 8px;

					.package-img {
						margin-top: 32px;
					}

					.route {
						display: flex;
						justify-content: center;

						.line {
							width: 647px;
							height: 0px;
							border: 2px dashed rgba(2, 127, 252, 0.8);
							margin-top: 7px;
						}
					}

					.city-name {
						display: flex;
						justify-content: space-between;
						padding: 16px;

						span {
							display: inline-block;
							width: 215px;
							font-size: 13px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 600;
							color: #333333;
						}
					}

				}

				.order-info {
					margin: 16px 0;
					@extend .flex1;

					.order-info-l {
						width: 286px;
						height: 36px;
						background: #FFFFFF;
						border-radius: 8px;
						margin-right: 16px;
						padding: 26px 0;
						@extend .font-class;
					}

					.order-info-r {
						width: 592px;
						height: 88px;
						background: #FFFFFF;
						border-radius: 8px;
						text-align: left;

						div {
							margin: 16px;
							font-size: 14px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: #333333;
						}

					}
				}

				.volume-info {
					@extend .flex1;
					margin: 16px 0;

					.volume-info-l {
						width: 564px;
						height: 112px;
						background: #FFFFFF;
						border-radius: 8px;
						margin-right: 8px;
						padding: 0 16px;

						.title {
							@extend .title-class;
						}

						.load-class {
							display: flex;
							align-items: center;

							.number {
								width: 38px;
								height: 56px;
								background: rgba(233, 85, 6, 0.04);
								border-radius: 8px;
								line-height: 56px;
							}

							span {
								margin: 0 8px;
							}

							.size {
								width: 498px;
								height: 36px;
								background: rgba(233, 85, 6, 0.04);
								border-radius: 8px;
								text-align: left;
								padding: 10px 16px;
								@extend .font-class;
							}
						}
					}

					.volume-info-r {
						width: 290px;
						height: 112px;
						background: #FFFFFF;
						border-radius: 8px;
						padding: 0 16px;

						.title {
							@extend .title-class;
						}

						.size {
							width: 258px;
							height: 36px;
							background: rgba(233, 85, 6, 0.04);
							border-radius: 8px;
							padding: 10px 0;
							@extend .font-class;
						}
					}
				}

				.last-info {
					@extend .flex1;
					margin: 16px 0;

					.carrier {
						width: 443px;
						height: 112px;
						background: #FFFFFF;
						border-radius: 8px;
						margin-right: 8px;
						padding: 0 16px;

						.title {
							@extend .title-class;
						}
					}

					.insurance {
						width: 443px;
						height: 112px;
						background: #FFFFFF;
						border-radius: 8px;
						padding: 0 16px;

						.title {
							@extend .title-class;
						}
					}
				}

				.tip-info {
					margin: 8px 0px;
					display: flex;
					width: 878px;
					//height: 54px;
					background: rgba(2, 127, 252, 0.04);
					border-radius: 4px;
					font-size: 13px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #027FFC;
					padding: 8px;
					text-align: left;

					img {
						margin-right: 8px;
					}
				}

				.footer-button {
					margin: 24px 0;

					button {
						width: 400px;
						height: 40px;
					}
				}
			}

			.content-r {
				width: 282px;
				margin-left: 24px;

				.price-detalls-bg {
					width: 282px;
					height: 88px;
					background: url('../../../../assets/img/client/booking/background_color.png');
					background-size: 282px 88px;
					text-align: left;
					line-height: 47px;

					span {
						font-size: 18px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 600;
						color: #FFFFFF;
						margin: 16px;
					}
				}

				.price-detalls {
					width: 250px;
					min-height: 188px;
					background: #FFFFFF;
					border-radius: 8px;
					position: relative;
					top: -40px;
					padding: 0 16px;

					.detalls-item,
					.detalls-Total {
						display: flex;
						justify-content: space-between;
						align-items: center;
						height: 40px;
					}

					.detalls-item {
						font-size: 13px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #333333;
					}

					.detalls-Total {
						font-size: 16px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 600;
						color: #333333;
					}

					.line {
						width: 250px;
						height: 0px;
						border: 1px dashed #DDDDDD;
						margin: 8px 0
					}

					.detalls-list {
						.detalls-item {
							@extend .detalls-item;
						}

						.left {
							text-align: left;
							color: #777777;
						}
					}
				}
			}
		}
	}
</style>
